import styled from 'styled-components';

const ActorThumbnail = styled.div`
  margin-right: 4px;
  height: 64px;
  cursor: pointer;
`;

export default ActorThumbnail;
